import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import App from '@/App';
import { queryClient } from '@/lib/queryClient';
import { ToastProvider } from '@/components/ui/toast';
// Self-hosted variable font (matches the 'Inter Variable' family in index.css).
// Previously index.html pulled static 'Inter' from Google Fonts, which never
// matched the CSS token (and added a render-blocking third-party request + CSP
// allowlist entries). Bundled woff2 ships with the app's own cache headers.
import '@fontsource-variable/inter';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}